import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agreements/$agreementId')({
  // `?from=<path>` is the referring party's detail page, so Back returns where the agreement was
  // opened from. Flat route by design — see AgreementDetailPage's header for why it is not nested
  // under each party tree.
  //
  // AR-704 — `?fromName=<party name>` accompanies it, so the breadcrumb can name the party you came
  // from. It is passed rather than derived because the two ids do NOT match: the agency route carries
  // the agency id while the agreement carries that agency's `primaryPartyId`.
  //
  // Validated to a string like `from`: search params are user-editable, so both are treated as
  // untrusted input and anything non-string becomes undefined. `fromName` is rendered as TEXT in a
  // breadcrumb — React escapes it — and is never used to build a URL or a query.
  validateSearch: (search: Record<string, unknown>): { from?: string; fromName?: string } => ({
    from: typeof search.from === 'string' ? search.from : undefined,
    fromName: typeof search.fromName === 'string' ? search.fromName : undefined,
  }),
});
